import React from "react";
import styles from "./sugessions.module.scss";

export const UniSugessions = ({ onChange, onClick }) => {
  const [suggestions, setSuggestions] = useState();
  const [showSuggestions, setShowSuggestions] = useState(true);

  const handleChange = (e) => {
    const [name, value] = e.target;
    if (onChange) {
      onChange(e);
    }

    //sugession open
    setShowSuggestions(true);
  };

  //handle outside
  useEffect(
    ({ onChange }) => {
      const checkIfClickedOutside = (e) => {
        if (showSuggestions && ref.current && !ref.current.contains(e.target)) {
          setShowSuggestions(false);
        }
      };
      document.addEventListener("mousedown", checkIfClickedOutside);
      return () => {
        document.removeEventListener("mousedown", checkIfClickedOutside);
      };
    },
    [showSuggestions]
  );

  return (
    <div className="sugwrap">
      <input
        type="text"
        name="location"
        className={styles.form_input}
        placeholder="Enter Country, State"
        autoComplete="off"
        onChange={handleChange}
        onClick={handleClick}
        value={value}
      />
      {showSuggestions && suggestions && suggestions.length > 0 && (
        <div className={styles.suggestions}>
          <ul>
            <FilterLocations />
          </ul>
        </div>
      )}
    </div>
  );
};
export default UniSugessions;
